// @flow
import * as React from 'react';
import styled from 'styled-components';

import { above } from '../../assets/css/media';

import Bg from './premiers-bg.jpg';

const Container = styled.div`
	display: flex;
	align-content: center;
	justify-content: center;
	flex-direction: column;
	background-image: url(${Bg});
	background-size: cover;
	background-position: 50% 20%;
	border-radius: 5px;
	padding: 20px 10px;
`;

const TeamWinnerText = styled.h3`
	font-size: 18px;
	line-height: 1.4
	font-weight: 700;
	color: #fff;
	text-align: center;
	margin: 14px 0 8px;

	${above.tablet`
		font-size: 30px;
	`}
`;

const UserWinnerText = styled.p`
	font-size: 14px;
	line-height: 1.2;
	color: #fff;
	text-align: center;
	margin: 0 0 14px;
`;

type Props = {
	team: string,
	firstname: string,
	lastname: string
}

export const PremiersWinnersBanner = ({ team, firstname, lastname }: Props) => {

	return <Container>
		<TeamWinnerText>{team} are the premiers!</TeamWinnerText>
		<UserWinnerText>Congratulations {firstname} {lastname}</UserWinnerText>
	</Container>;
};

export default PremiersWinnersBanner;


// WEBPACK FOOTER //
// ./src/components/PremiersWinnersBanner/index.js